import "./ambHero.css";

/* The career centre hero, rebuilt for this page: same geometry, same type
   scale, same entrance. Only the copy and the photograph change. */

import { FadeIn } from "../../ui/fade-in";
import heroPhoto from "../../../assets/ambassador-group-photo.webp";

/* The apply form at the foot of the page, not a mail client. */
const APPLY = "#apply";

const AmbHero = () => (
  <section className="amb-hero">
    <div className="home-container amb-hero-grid">
      <div className="amb-hero-copy">
        {/* Not "RAIN for ambassadors" like its siblings: the other pages name
            an audience the product serves, and this one is a programme you
            join. .amb-eyebrow already carried the blue treatment for the
            section heads below — this is the same one. */}
        <FadeIn delay={0}>
          <span className="amb-eyebrow">RAIN ambassador program</span>
        </FadeIn>

        <FadeIn delay={0.1}>
          <h1 className="amb-hero-title">
            Join RAIN as a campus ambassador and earn up to{" "}
            <span className="amb-hero-offer">
              <span className="amb-hero-figure">$10,000</span> a semester
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.2}>
          <p className="amb-hero-sub">
            Run the campaigns that get students onto RAIN, try new features
            before they ship, and tell us what to build next, with the
            budget and the sign-off to actually do it.
          </p>
        </FadeIn>

        <FadeIn delay={0.3}>
          <a className="amb-hero-btn" href={APPLY}>
            Apply now
          </a>
        </FadeIn>
      </div>

      <FadeIn delay={0.2} className="amb-hero-photo">
        <img width={1086} height={815} decoding="async" src={heroPhoto} alt="RAIN campus ambassadors on a community call" />
      </FadeIn>
    </div>
  </section>
);

export default AmbHero;
